import React, { useState, useEffect } from "react";
import {
    Accordion, AccordionSummary, AccordionDetails,
    Typography, Grid, Box, TextField, IconButton, CircularProgress
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import NakdanButton from "../../SharedArea/NakdanButton";

import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";
import audio from "../../../Utils/audioPlayer";

const ExistsTrnsArSection = observer(() => {
    const existsInfo = additionalInfo.existsInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const [editedTrnsAr, setEditedTrnsAr] = useState({});

    useEffect(() => {
        if (existsInfo?.trnsAr) {
            setEditedTrnsAr(
                existsInfo.trnsAr.reduce((acc, trns_ar) => {
                    acc[trns_ar._id] = trns_ar.text;
                    return acc;
                }, {})
            );
        }
    }, [existsInfo]);

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, trnsAr: !expanded.trnsAr });
    };

    const isHebrew = (text) => /^[\u0590-\u05FF]/.test(text.trim());
    const playAudioFile = (fileName) => {
        const src = `https://lexillon-files-il.s3.il-central-1.amazonaws.com/files/audio/additional-info/${fileName}`;
        audio.pause();
        audio.src = src;
        audio.play();
    };

    return (
        <Grid item xs={12}>
            <Accordion
                expanded={expanded.trnsAr}
                onChange={() => handleToggle("trnsAr")}
                sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({existsInfo.trnsAr?.length || 0}) תרגום לערבית</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ width: "100%", textAlign: "center" }}>
                        {existsInfo.trnsAr?.length > 0 ? (
                            existsInfo.trnsAr.map((trns_ar) => {
                                const text = editedTrnsAr[trns_ar._id] || "";
                                const lang = isHebrew(text) ? "heIL" : "enUS";
                                const audioData = trns_ar.audio?.[lang] || {};
                                const maleFile = audioData.male;
                                const femaleFile = audioData.female;

                                return (
                                    <Box
                                        key={trns_ar._id}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            bgcolor: "#f0f0f0",
                                            p: 1,
                                            pt: 0,
                                            borderRadius: 2,
                                            mt: 0.5
                                        }}
                                    >
                                        <Box sx={{ display: "flex", gap: 0.5, ml: 1 }}>
                                            {/* כפתורי אודיו */}
                                            <IconButton
                                                onClick={() => maleFile && playAudioFile(maleFile)}
                                                disabled={!maleFile}
                                            >
                                                <VolumeUpIcon titleAccess="איש" />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => femaleFile && playAudioFile(femaleFile)}
                                                disabled={!femaleFile}
                                            >
                                                <VolumeUpIcon titleAccess="אשה" />
                                            </IconButton>

                                            {/* כפתור ניקוד */}
                                            <NakdanButton
                                                text={text}
                                                onNikudComplete={(nikudText) => {
                                                    setEditedTrnsAr(prev => ({
                                                        ...prev,
                                                        [trns_ar._id]: nikudText,
                                                    }));
                                                }}
                                            />

                                            {/* שמירה / מחיקה */}
                                            <IconButton
                                                onClick={() =>
                                                    additionalInfo.updateExistsInfo(
                                                        existsInfo._id,
                                                        "trnsAr",
                                                        trns_ar._id,
                                                        { text: editedTrnsAr[trns_ar._id] }
                                                    )
                                                }
                                                disabled={loading.updateExistsInfo.trnsAr?.[trns_ar._id] === "text"}
                                            >
                                                {loading.updateExistsInfo.trnsAr?.[trns_ar._id] === "text"
                                                    ? <CircularProgress size={24} />
                                                    : <SaveIcon color="primary" />}
                                            </IconButton>
                                            <IconButton
                                                onClick={() =>
                                                    additionalInfo.deleteExistsInfo(
                                                        existsInfo._id,
                                                        "trnsAr",
                                                        trns_ar._id
                                                    )
                                                }
                                                disabled={loading.deleteExistsInfo.trnsAr?.[trns_ar._id]}
                                            >
                                                {loading.deleteExistsInfo.trnsAr?.[trns_ar._id]
                                                    ? <CircularProgress size={24} />
                                                    : <DeleteIcon color="error" />}
                                            </IconButton>
                                        </Box>

                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            multiline
                                            minRows={1}
                                            value={text}
                                            onChange={(e) =>
                                                setEditedTrnsAr({
                                                    ...editedTrnsAr,
                                                    [trns_ar._id]: e.target.value,
                                                })
                                            }
                                            sx={{
                                                direction: isHebrew(text) ? "ltr" : "rtl"
                                            }}
                                        />
                                    </Box>
                                );
                            })
                        ) : (
                            <Typography variant="body2" color="textSecondary">אין תרגומים לערבית זמינים</Typography>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default ExistsTrnsArSection;
